import React,{useCallback} from 'react'
import ActorForm from './ActorForm'
import List from '@commonComponents/List'
import { useDispatch } from 'react-redux'
import useValidationAES from '../../../..//hooks/useValidationAES'

const ActorDetails = ({ dataSource, onBlur,deleteData, ...rest }) => {
    const {updateMerchActorsError} = useValidationAES()
    const dispatch = useDispatch()
    const renderItem = useCallback(({ id, ...restItem }) => {
        const onBlurHandler = (tableName, params) => {
            onBlur(tableName, params)
            dispatch(updateMerchActorsError(tableName))
        }
        const onDeleteHandler = async (id, tableName) =>{
            await deleteData(id, tableName)
            dispatch(updateMerchActorsError(tableName))
        }
        return <ActorForm
            key={id}
            dataSource={{ id, ...restItem }}
            onBlur={onBlurHandler}
            deleteData={onDeleteHandler}
            {...rest}
        />
    },
        [rest]
    )
    return (<List
        className='responsiveGridCss'
        dataSource={dataSource}
        renderItem={renderItem}
    />)
}

export default ActorDetails